import { useMemo } from "react";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { selectorPayoutSettingsInstantFee } from "@selectors/selectorPayoutSettingsInstantFee";

export function useInstantPayoutFee() {
  const queryPayoutSettings = useQueryOwnPayoutSettings();
  return useMemo(
    () => selectorPayoutSettingsInstantFee(queryPayoutSettings.data),
    [queryPayoutSettings.data]
  );
}
